import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LoadingComponent from "../views/components/LoadingComponent";

const ProtectedRoute = () => {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return <LoadingComponent/> // or show a loading spinner
    }
    return isAuthenticated ? (
        <Outlet />
    ) : (
        <Navigate to="/_/login" state={{ from: location }} replace />
    );
};

export default ProtectedRoute;